import React, {Suspense} from "react";
import {Switch} from "react-router-dom";
import {LayoutSplashScreen, ContentRoute} from "../../../_metronic/layout";
import {CompleteDetailsPage as CompleteDetails} from './pages/CompleteDetailsPage';

export default function CompleteDetailsPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/complete-details" component={CompleteDetails}/>
      </Switch>
    </Suspense>
  );
}
